import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Row, Col, Divider, Card, List, Icon, Collapse } from "antd";
import _ from "lodash";
import qs from "query-string";

import { parseKeys, parseValues } from "../../Utils/catalogues";
const Panel = Collapse.Panel;

class OrderDetailComponent extends React.Component {
  getParsedValues = fields => {
    const parsed = _.map(fields, field => {
      // let value = null;
      // if (field.value) {
      //   value = _.compact(_.values(_.omit(field.value, ["__typename"])))[0];
      // }
      // return { ...field, value };

      return { ...field, value: JSON.parse(field.value) };
    });

    return parsed;
  };

  renderListItem = item => {
    if (item.type === "file") {
      return (item.value && item.value.key) || "No se agregó archivo.";
    } else if (item.type === "multifile") {
      if (item.value && item.value.length) {
        return (
          <ul>
            {_.map(item.value, item => <li key={item.key}>{item.key}</li>)}
          </ul>
        );
      }
      return "No se agregaron archivos.";
    } else if (item.type === "password") {
      return "********";
    } else if (item.type === "switch") {
      return item.value ? "Sí" : "No";
    }

    return parseValues(item.fieldName, item.value);
  };

  renderList = data => {
    return (
      <List
        itemLayout="horizontal"
        dataSource={data}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              title={item.label}
              description={this.renderListItem(item)}
            />
          </List.Item>
        )}
      />
    );
  };

  renderViews = view => {
    const {
      order: { fields, serviceSteps }
    } = this.props;

    const data = _.groupBy(
      this.getParsedValues(_.orderBy(fields, ["step", "order"])),
      "step"
    );
    if (view === "data") {
      return (
        <Collapse accordion defaultActiveKey={"1"}>
          {_.map(data, (mData, key) => {
            const header = _.find(serviceSteps, ["step", parseInt(key, 10)])
              .label;
            return (
              <Panel header={header} key={key}>
                {this.renderList(mData)}
              </Panel>
            );
          })}
        </Collapse>
      );
    }
    return null;
  };

  renderTitle = view => {
    if (view === "data") {
      return "Información Proporcionada";
    }
    return "";
  };

  renderExtra = view => {
    const { orderId } = this.props;
    if (view === "data") {
      return (
        <Link to={`/orders/${orderId}`}>
          <Icon type="bars" /> Ver detalle
        </Link>
      );
    }
    return null;
  };

  render() {
    const { order, orderId, location } = this.props;
    const query = qs.parse(location.search);
    const orderAttsList = _.reject(
      Object.entries(order).map(([key, value]) => {
        if (key !== "category") {
          return {
            key,
            value
          };
        }

        return {
          key,
          value: value.title
        };
      }),
      o =>
        o.key === "__typename" ||
        o.key === "fields" ||
        o.key === "serviceSteps" ||
        o.key === "serviceId"
    );

    return (
      <Row className="order-detail-container">
        <Row>
          <h2>Detalle de la orden</h2>
          <p>{order.serviceTitle}</p>
          <Divider />
        </Row>
        <Row gutter={24}>
          <Col>
            <Card
              title={query.view ? this.renderTitle(query.view) : "Detalle"}
              style={{ boxShadow: "var(--shadow-super-light)" }}
              extra={
                query.view ? (
                  this.renderExtra(query.view)
                ) : (
                  <Link to={`/orders/${orderId}?view=data`}>
                    <Icon type="bars" /> Ver información
                  </Link>
                )
              }
            >
              {query.view ? (
                this.renderViews(query.view)
              ) : (
                <List
                  itemLayout="horizontal"
                  dataSource={orderAttsList}
                  renderItem={item => (
                    <List.Item>
                      <List.Item.Meta
                        title={parseKeys[item.key]}
                        description={parseValues(item.key, item.value)}
                      />
                    </List.Item>
                  )}
                />
              )}
            </Card>
          </Col>
        </Row>
      </Row>
    );
  }
}

export default withRouter(OrderDetailComponent);



// WEBPACK FOOTER //
// ./src/Components/Orders/OrderDetailComponent.js